import React from 'react';
import Clint01 from '../../assets/image/partners/1.png';
import Clint02 from '../../assets/image/partners/2.png';
import Clint03 from '../../assets/image/partners/3.png';
import Clint04 from '../../assets/image/partners/4.png';
import Clint05 from '../../assets/image/partners/8x8-Logo-DkGrey.jpg';
import OwlCarousel from 'react-owl-carousel';

function Client() {
  const settings = {
    items: 1,
    nav: false,
    dots: false,            // remove dot block that adds bottom height
    margin: 80,
    loop: true,
    autoplay: true,
    smartSpeed: 2000,
    responsive: {
      0:   { items: 1 },
      375: { items: 2 },
      767: { items: 3 },
      991: { items: 4 },
      1199:{ items: 5 },
    },
  };

  const itemBox = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 120,
    height: 120,
    boxSizing: 'border-box',
    overflow: 'hidden',
  };

  const imgBase = {
    display: 'block',
    margin: '0 auto',
    width: 120,
    height: 120,
    objectFit: 'contain',
  };

  return (
    <>
      {/* Hard overrides to kill extra vertical whitespace from theme/Owl */}
      <style>{`
        .client-section { padding-top: 24px; padding-bottom: 12px; }
        .client-section .client-text { margin: 0 0 8px !important; text-align: center; }
        .client-section .container { padding-top: 0 !important; padding-bottom: 0 !important; margin-top: 0 !important; margin-bottom: 0 !important; }
        .client-section .client-carousel { margin: 0 !important; padding: 0 !important; }
        .client-section .client-carousel .owl-stage-outer { margin: 0 !important; padding: 0 !important; }
        .client-section .owl-theme .owl-dots { margin-top: 0 !important; } /* dots disabled anyway */
        .client-section .owl-theme .owl-nav { margin-top: 0 !important; }
      `}</style>

      <section className="client-section">
        <h5 className="client-text">Our partners &amp; supporters</h5>

        {/* Tight gap between heading and icons */}
        <div className="container" style={{ marginTop: 8 }}>
          <OwlCarousel className="client-carousel owl-carousel owl-theme" {...settings}>
            <div className="item" style={itemBox}>
              <img
                src={Clint01}
                className="img-fluid"
                alt="Partner 1"
                style={{ ...imgBase, transform: 'scale(1.45)', transformOrigin: 'center' }}
              />
            </div>

            <div className="item" style={itemBox}>
              <img
                src={Clint02}
                className="img-fluid"
                alt="Partner 2"
                style={{ ...imgBase, transform: 'scale(1.45)', transformOrigin: 'center' }}
              />
            </div>

            <div className="item" style={itemBox}>
              <img
                src={Clint03}
                className="img-fluid"
                alt="Partner 3"
                style={{ ...imgBase, transform: 'scale(1.45)', transformOrigin: 'center' }}
              />
            </div>

            <div className="item" style={itemBox}>
              <img
                src={Clint04}
                className="img-fluid"
                alt="Partner 4"
                style={{ ...imgBase, transform: 'scale(1.45)', transformOrigin: 'center' }}
              />
            </div>

            <div className="item" style={itemBox}>
              <img
                src={Clint05}
                className="img-fluid"
                alt="Partner 5"
                style={imgBase}
              />
            </div>
          </OwlCarousel>
        </div>
      </section>
    </>
  );
}

export default Client;
